<span [class]="'status-chip ' + variant()">{{ statusName() | translate }}</span>
